import React from 'react'
import {Link} from 'react-router-dom'
import List from './List'
import AliceCarousel from 'react-alice-carousel';
import ActiveWrapper from './common/ActiveWrapper'
import attendance from '../images/apps/attendance.png'
import attendanceApp from '../images/apps/attendance-app.svg'
import projectAndtaskApp from '../images/apps/projects-app.svg'
import serviceTicketingApp from '../images/apps/icon-service.svg'
import inventoryApp from '../images/apps/inventory-app.svg'
import surveyfeedback from '../images/apps/survey-feedback.svg'
import deliveryApp from '../images/apps/delivery-app.svg'
import claims from '../images/apps/claims.png'
import leadTrackerApp from '../images/apps/lead-tracker-app.svg'
import securityApp from '../images/apps/security-app.svg'
import usermgtApp from '../images/apps/user-mgt-social.svg'
import billingApp from '../images/apps/billing-app.svg'
import locationApp from '../images/apps/location-mgt.svg'
import referalApp from '../images/apps/referal-app.svg'
import learningApp from '../images/apps/learning-app.svg'
import survey from '../images/apps/survey.png'
import learning from '../images/apps/learning.png'
import leadTracker from '../images/apps/lead-tracker.png'
import social from '../images/apps/social.png'
import serviceTicketing from '../images/apps/services.png'
import projectAndtask from '../images/apps/projects-n-tasks.png'
import location from '../images/apps/location-mgt.png'
import delivery from '../images/apps/delivery.png'
import orderMngt from '../images/apps/order-management.png'
import customerIconApp from '../images/apps/customer-icon-app.svg'
import customerIcon from '../images/apps/vendor-management.png'
import inventory from '../images/apps/inventory-management.png'
import billing from '../images/apps/billing.png'
import collection from '../images/apps/collection.png'
import purchaseRequestApp from '../images/apps/purchase-request-app.svg'
import purchaseRequest from '../images/apps/purchase-requisition.png'
import claimsApp from '../images/apps/claims-app.svg'
import collectionApp from '../images/apps/collection-icon-app.svg'
import customerManagement from '../images/apps/customer-management.png'
import customerManagementApp from '../images/apps/customer-icon-app.svg'
import incentives from '../images/apps/incentives.png'
import incentivesApp from '../images/apps/icon-leaderboard.svg'
import distributorMgtApp from '../images/apps/distributor-mgt-icon-app.svg'
import distributorMgt from '../images/apps/distributor-mgt.png'
import crmApp from '../images/apps/crm-icon.svg'
import AssetMgtApp from '../images/apps/Asset-Mgt-icon.svg'
import buildYourOwnApp from '../images/apps/custom-app-icon@2x.png'
import AssetMgt from '../images/apps/AssetMgt.png'
import crm from '../images/apps/customer-management.png'
import referal from '../images/apps/Referrals.png'





const appMobileImages = {
    attendance,
    claims,
    survey,
    learning,
    leadTracker,
    social,
    serviceTicketing,
    projectAndtask,
    location,
    delivery,
    orderMngt,
    customerIcon,
    inventory,
    billing,
    collection,
    purchaseRequest,
    customerManagement,
    incentives,
    distributorMgt,
    AssetMgt,
    crm,
    referal
}

const appIcons = {
    attendance:attendanceApp,
    projectAndtask:projectAndtaskApp,
    serviceTicketing:serviceTicketingApp,
    inventory:inventoryApp,
    survey:surveyfeedback,
    delivery:deliveryApp,
    leadTracker:leadTrackerApp,
    security:securityApp,
    social:usermgtApp,
    billing:billingApp,
    location:locationApp,
    referal:referalApp,
    learning:learningApp,
    orderMngt:deliveryApp,
    customerIcon :customerIconApp,
    purchaseRequest:purchaseRequestApp,
    claims:claimsApp,
    collection:collectionApp,
    customerManagement:customerManagementApp,
    incentives:incentivesApp,
    distributorMgt:distributorMgtApp,
    crm:customerManagementApp,
    AssetMgt:AssetMgtApp,
    buildYourOwn:buildYourOwnApp
/*
    customerManagement:customerManagementApp
*/
}

const listingUrl = {
    hr:'/solutions/employee-engagement',
    sales:'/solutions/sales/'
}

const responsive = {
    0: {
        items: 1
    },
    320: {
        items: 1
    },
    650:{
        items: 2
    },
    767: {
        items: 3
    },
    1260: {
        items: 4
    },
    1460: {
        items: 5
    }
};
class AppListItem extends React.Component{
    onClickContent(){
        const {itemData} = this.props
        if(!itemData.noClick){
            this.props.onClickApps(itemData)
        }

    }
    render(){
        const {itemData,previewImg} = this.props
        return <li className={previewImg === itemData.image ? `app-li ${itemData.app} active ${itemData.image}` : `app-li ${itemData.app} ${itemData.image}`}  key={itemData.id} id={itemData.id} onClick={this.onClickContent.bind(this)}
        >
            <ActiveWrapper active={itemData.id !== 'explore'}>
                <div data-aos="fade-left" data-aos-offset="10" className={'app-list-cls'}>
                <div className={'image'}>
                    <img src={appIcons[itemData.image]}/>
                </div>
                <div className={'title'}>{itemData.title}</div>
                <p className={'discription'}>{itemData.description}</p>
{/*
                <div className={'load-more'}>Learn More </div>
*/}
                </div>
            </ActiveWrapper>
         {/*  <ActiveWrapper active={itemData.id === 'explore'}>
                <div className={'show-more'}>
                    <button className={'bt-blue explore-all'}>Build your own</button>
                </div>
            </ActiveWrapper>*/}
            </li>
    }
}

export class ShowApps extends React.Component{
    constructor(){
        super()
        this.state = {
            activeId:'hr',
            listWidth:70,
            marginLeft:0,
            previewImg:'leadTracker'
        }
    }
    onClickApps(item){
        this.setState({
            previewImg:item.image
        })
    }
    menuClickHandler(id,event){
        const offSet = event.target.getBoundingClientRect()
        const {appsData = []} = this.props;
        const selectedList = appsData.filter(item=>item.app === id);
        this.setState({
            activeId:id,
            listWidth:offSet.width,
            marginLeft:event.target.offsetLeft,
            previewImg:selectedList[0].image
        })
    }
    onSlideChanged(selectedList,event){
        const activeApp = selectedList[event.item]
        this.previewImg.src = appMobileImages[activeApp.image]
     }
    galleryItems(selectedList){
        return (
            selectedList.map(function(item, i) {return <AppListItem id={item.id} key={item.id} itemData={{...item,noClick:true}} onClickApps={this.onClickApps.bind(this)} previewImg={this.state.previewImg}></AppListItem>},this)
        )
    }
    render(){
        const {appsData = []} = this.props;
        const selectedList = appsData.filter(item=>item.app === this.state.activeId);
        return <div className={'show-apps-container'}>
            <div className={'menu-list'} data-aos="fade-up" >
                <div className={'empty-div'}></div>
                <div className={'list-ul'}>
                    <ul>
                        <li onClick={this.menuClickHandler.bind(this,'hr')} className={this.state.activeId === 'hr' ? 'active' : ''}>HR</li>
                        <li onClick={this.menuClickHandler.bind(this,'sales')} className={this.state.activeId === 'sales' ? 'active' : ''}>Sales</li>
                        <li onClick={this.menuClickHandler.bind(this,'service')} className={this.state.activeId === 'service' ? 'active' : ''}>Services</li>
                        <li onClick={this.menuClickHandler.bind(this,'operations')} className={this.state.activeId === 'operations' ? 'active' : ''}>Operations</li>
                        <li onClick={this.menuClickHandler.bind(this,'finance')} className={this.state.activeId === 'finance' ? 'active' : ''}>Finance</li>
                        {/*
                    <li onClick={this.menuClickHandler.bind(this,'admin')} className={this.state.activeId === 'Admin' ? 'active' : ''}>Admin</li>
*/}
                        <hr style={{width:this.state.listWidth,left:this.state.marginLeft}}/>
                    </ul>
                </div>
            </div>
            <div className={'show-apps-list-container'}>
                <div className={'preview-apps'}>

                    <img src={appMobileImages[this.state.previewImg] || ''} className={'pre-img'} ref={img => this.previewImg = img}/>
                </div>
                <div className={'show-app-list-mobile'}>
                    <AliceCarousel
                        items={this.galleryItems(selectedList)}
                        duration={400}
                        responsive={responsive}
                        fadeOutAnimation={true}
                        mouseDragEnabled={false}
                        autoPlay={false}
                        startIndex = {this.state.startIndex}
                        playButtonEnabled={false}
                        autoPlayInterval={5000}
                        autoPlayDirection="ltr"
                        onSlideChanged={this.onSlideChanged.bind(this,selectedList)}
                    />
                </div>
                <div className={'show-app-list'}>
                    <List items={[...selectedList,{id:'explore',title:'Explore All',app:'explore',noClick:true}]} listItem={AppListItem} className={'apps-ul-list'} onClickApps={this.onClickApps.bind(this)} previewImg={this.state.previewImg}/>
                    {this.state.activeId === 'hr' || this.state.activeId === 'sales' ? <div className={'explore-all'}>
                        <button className={'bt-blue bt'}><Link to={listingUrl[this.state.activeId ]}>Explore All</Link></button>
                    </div> : null}
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/ShowApps.js